import { Drawer } from "@mui/material";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
const ReportDrawer = ({ open, handleClose }) => {
  const { enqueueSnackbar } = useSnackbar();
  const organisation_report_url = useSelector(
    (e) => e.reports.organisationReportUrl
  );
  const organisation_report_url_loading = useSelector(
    (e) => e.reports.isOrganisationReportUrlLoading
  );
  const organisation_report_url_error = useSelector(
    (e) => e.reports.isOrganisationReportUrlError
  );

  useEffect(() => {
    if (organisation_report_url_error) {
      enqueueSnackbar(organisation_report_url_error, {
        variant: "error",
        onClose: handleClose,
      });
      handleClose();
    }
  }, [organisation_report_url_error]);
  return (
    <Drawer
      id="reports"
      anchor="right"
      sx={{
        "& .MuiDrawer-paper": {
          display: "grid",
          placeItems: "center",
        },
      }}
      open={open}
      onClose={handleClose}>
      {organisation_report_url_loading && "Loading..."}
      {!organisation_report_url_loading && !organisation_report_url_error && (
        <iframe
          src={organisation_report_url}
          width="100%"
          height="100%"
          style={{ display: "block", position: "relative" }}></iframe>
        // />
      )}
    </Drawer>
  );
};
export default ReportDrawer;
